// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminSidebar_sidebar__0LUsh {
  width: 25rem;
  background-color: var(--color-grey-3);
  height: 100dvh;
  padding: 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  position: fixed;
  z-index: 100;
}
.AdminSidebar_sidebar__container__sU-WR {
  background-color: rgba(42, 40, 40, 0.7);
  width: 100%;
  height: 100dvh;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
}
.AdminSidebar_sidebar__container__sU-WR > :last-child {
  flex: 1 1;
}

.AdminSidebar_sb_logo__gLzMK {
  height: 3rem;
}
.AdminSidebar_sb_nav__cmc0C {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
}
.AdminSidebar_sb_nav__item__uka\\+s {
  display: flex;
  gap: 1rem;
  align-items: center;
  padding: 1.2rem;
  border-radius: 1rem;
  cursor: pointer;
}
.AdminSidebar_sb_nav__item__active__YKZc\\+, .AdminSidebar_sb_nav__item__uka\\+s:hover {
  background-color: var(--color-fash-black);
  color: var(--color-white);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Admin/AdminSidebar.module.scss"],"names":[],"mappings":"AAAA;EACC,YAAA;EACA,qCAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;AACD;AACC;EACC,uCAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;AACF;AACE;EACC,SAAA;AACH;;AAKC;EACC,YAAA;AAFF;AAKC;EACC,aAAA;EACA,sBAAA;EACA,WAAA;AAHF;AAKE;EACC,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;AAHH;AAKG;EAEC,yCAAA;EACA,yBAAA;AAJJ","sourcesContent":[".sidebar {\n\twidth: 25rem;\n\tbackground-color: var(--color-grey-3);\n\theight: 100dvh;\n\tpadding: 1.6rem;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 2rem;\n\tposition: fixed;\n\tz-index: 100;\n\n\t&__container {\n\t\tbackground-color: rgba(#2a2828, 0.7);\n\t\twidth: 100%;\n\t\theight: 100dvh;\n\t\tdisplay: flex;\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tz-index: 100;\n\n\t\t& > :last-child {\n\t\t\tflex: 1;\n\t\t}\n\t}\n}\n\n.sb {\n\t&_logo {\n\t\theight: 3rem;\n\t}\n\n\t&_nav {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 1.6rem;\n\n\t\t&__item {\n\t\t\tdisplay: flex;\n\t\t\tgap: 1rem;\n\t\t\talign-items: center;\n\t\t\tpadding: 1.2rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tcursor: pointer;\n\n\t\t\t&__active,\n\t\t\t&:hover {\n\t\t\t\tbackground-color: var(--color-fash-black);\n\t\t\t\tcolor: var(--color-white);\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `AdminSidebar_sidebar__0LUsh`,
	"sidebar__container": `AdminSidebar_sidebar__container__sU-WR`,
	"sb_logo": `AdminSidebar_sb_logo__gLzMK`,
	"sb_nav": `AdminSidebar_sb_nav__cmc0C`,
	"sb_nav__item": `AdminSidebar_sb_nav__item__uka+s`,
	"sb_nav__item__active": `AdminSidebar_sb_nav__item__active__YKZc+`
};
export default ___CSS_LOADER_EXPORT___;
